import { SET_SELECTED_ORDER_LINE } from '../../types';

const setSelectedOrderLine = (selectedOrderLine) => (dispatch) => {
  dispatch({ type: SET_SELECTED_ORDER_LINE, selectedOrderLine });
};

export { setSelectedOrderLine };
